import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SeriesTitle from 'react/views/series/SeriesTitle';
import MeasuredCarouselView from 'react/views/carousel/MeasuredCarouselView';
import ResultsHeader from 'react/views/generic/ResultsHeader';
import { CarouselItemWidth } from 'react/views/carousel/CarouselItem';
import withOtsEnabled from 'react/containers/helper/withOtsEnabled';


class CarouselSearchResults extends Component {
    renderBooks() {
		const carouselTitles = this.props.resultData && this.props.resultData.titles.map((title) => {
			return (
				<SeriesTitle 
					key={title.uniqueId}
					title={title}
					jacketClickEvent={this.props.jacketClickEvent}
					titleClickEvent={this.props.titleClickEvent}
					otsFindItEvent={this.props.otsFindItEvent}
					otsClickEvent={this.props.otsClickEvent}
					otsEnabled={this.props.otsEnabled}
					closeModal={this.props.closeModal}
				/>
			);
		});
		return carouselTitles;
    }
    
    renderHeader() {
		return (
			<ResultsHeader
				resultData={this.props.resultData.titles}
				headerText={this.props.resultsHeader}
				headerSummary={this.props.resultData.summary}
			/>
		);
	}

    render() {
		return (
			<MeasuredCarouselView
				header={this.renderHeader()}
				footer={this.props.linkToNovelist}
				items={this.renderBooks()}
				itemWidth={CarouselItemWidth}
				marginBottom={"1em"}
			/>
		);
	}
}

CarouselSearchResults.propTypes = {
	bookLevel: PropTypes.number,	
    resultData: PropTypes.object,
    resultsHeader: PropTypes.string,
    otsClickEvent: PropTypes.object,
    jacketClickEvent: PropTypes.object,
    titleClickEvent: PropTypes.object,
    otsFindItEvent: PropTypes.object,
	closeModal: PropTypes.func
};

export default withOtsEnabled(CarouselSearchResults);


// WEBPACK FOOTER //
// ./src/react/views/readingLevel/CarouselSearchResults.jsx